import { useState } from 'react'
import GoogleMapReact from 'google-map-react';
import React from 'react';
import mapStyleData from '../map.json';

const MapPicker = ({ location, setLocation }) => {
  const Marker = () => <div>📍</div>; 
  const [selectedLocation, setSelectedLocation] = useState({});

  const handleMapClick = ({ lat, lng }) => {
    setLocation({ lat, lng });
    setSelectedLocation({ lat, lng });
  };

  const API_KEY = "AIzaSyAAa0Poy6oJW0ZV8HdJBynbnExTKICHrSk";


  const mapStyle = mapStyleData;

  return (
    <div className="h-96 w-full">
      {location.lat !== 0 && location.lng !== 0 ? (
        <GoogleMapReact
          bootstrapURLKeys={{ key: API_KEY }}
          defaultCenter={location}
          defaultZoom={16}
          yesIWantToUseGoogleMapApiInternals
          onClick={handleMapClick}
          options={{
            styles: mapStyle
          }}
          className="h-full w-full"
        >
          {selectedLocation && <Marker lat={selectedLocation.lat} lng={selectedLocation.lng} />}
        </GoogleMapReact>
      ) : (
        <div className="h-full w-full flex items-center justify-center text-gray-500">
          Loading map...
        </div>
      )}
    </div>
  );
};

export default function SimpleMap(props) {
  return <MapPicker location={props.location} setLocation={props.setLocation} />;
}
